export default __webpack_public_path__ + "static/media/peopleIcon.387a6868.svg";